import { HttpClient, ListParams } from './http-client';
import { Observable } from 'rxjs';
import Paginate from '../interfaces/paginate';
import VaadLizReportsHistory from '../interfaces/vaadLizReportsHistory';

export class VaadLizReportService extends HttpClient {
  index(
    farmId: string,
    params: ListParams
  ): Observable<Paginate<VaadLizReportsHistory>> {
    return this.get<Paginate<VaadLizReportsHistory>>(
      `/api/farms/${farmId}/vaad-liz-reports/reports/`,
      params
    );
  }

  downloadHistoryReportsZip(farmId: string, zipId: string) {
    return this.export(
      `/api/farms/${farmId}/vaad-liz-reports/reports/download-report-zip/${zipId}`
    );
  }
}
